import template from './tenants-type.jade';
import tenantsType from '../../../enums/tenants-type';

export default angular
    .module('cian.addForm.tenantsType', [])
    .directive('cianAfPriceAndDealTermsTenantsType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.tenantsTypes = tenantsType;
            if (!this.ad.bargainTerms.tenantsType) {
                this.ad.bargainTerms.tenantsType = this.tenantsTypes[0].value;
            }
        },
        controllerAs: 'tenantsType',
        template,
    }))
    .name;
